import { Component, inject } from "@angular/core";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-blog',
    imports: [],
    templateUrl: './blog.component.html',
    styleUrl: './blog.component.scss'
})

export class BlogComponent {
    
    private apiService: ApiService = inject(ApiService)

    ngOnInit(): void {
        this.apiService.getArticles()
        this.apiService.getAteliers()
    }
}